import React, { useEffect } from 'react';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

// Array de documentos con sus títulos y rutas correspondientes
const documentos = [
  {
    title: "Acuerdo que crea el Comité de Control Interno y Desempeño Institucional de la Secretaría de Contraloría.",
    pdfUrl: "/micro/antecedentes/1. Acuerdo que crea el Comité de Control Inermo y Desempeño Institucional de la Secretaría de Contraloría.pdf"
  },
  {
    title: "Lineamientos Generales para la Integración, Organización y Funcionamiento de los Comités de Ética y Prevención de Conflictos de Interés.",
    pdfUrl: "/micro/antecedentes/4.Lineamientos Generales para la Integración, Organización y Funcionamiento de los Comités de Ética y Prevención de Conflictos de Interés.pdf"
  },
  {
    title: "Acuerdo que crea el Comité de Ética y Prevención de Conflictos de Interés de la Secretaría de Contraloría del Poder Ejecutivo del Estado de Hidalgo",
    pdfUrl: "/micro/antecedentes/2. Acuerdo que crea el Comité de Ética y Prevención de Conflictos de Interes de la Secretaría de Contraloría del Poder Ejecutivo del Estado de Hidalgo.pdf"
  },
  {
    title: "Código de Ética de la Administración Pública del Estado de Hidalgo.",
    pdfUrl: "/micro/antecedentes/5.Código de Ética de la Administración Pública del Estado de Hidalgo.pdf"
  },
  {
    title: "Disposiciones y Manual Administrativo de Aplicación Estatal en Materia de Control Interno.",
    pdfUrl: "/micro/antecedentes/3. Disposiciones y Manual Administrativo de Aplicación Estatal en Materia de Control Interno.pdf"
  },
  {
    title: "Modelo Estatal de Marco Integrado de Control Interno para el Sector Público del Estado de Hidalgo.",
    pdfUrl: "/micro/antecedentes/6. Modelo Estatal de Marco Integrado de Control Interno para el Séctor Público del Estado de Hidalgo.pdf"
  }
];

const AntecedentesNormativos = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <HeaderSCI title="ANTECEDENTES NORMATIVOS" />

      {/* ── DOCUMENT LIST ── */}
      <div className="container ci-nav" style={{ maxWidth: '1000px' }}>
        <div className="row justify-content-center">
          {documentos.map((doc, idx) => (
            <div key={idx} className="col-lg-6 col-md-6 col-12 mb-2">
              <a 
                href={doc.pdfUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="ci-nav__btn ci-nav__btn--doc"
              >
                <div className="ci-nav__icon">
                  <i className="fa-regular fa-address-card"></i>
                </div>
                <span className="ci-nav__label ci-nav__label--doc">{doc.title}</span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AntecedentesNormativos;